import { useCallback, useEffect, useMemo, useState } from "react";
import useEmblaCarousel, {
  EmblaCarouselType
} from "embla-carousel-react";

const useImageComparisonSlider = () => {
  const [emblaRef, emblaApi] = useEmblaCarousel({
    watchDrag: false,
    loop: true
  });
  const [prevBtnDisabled, setPrevBtnDisabled] = useState(true);
  const [nextBtnDisabled, setNextBtnDisabled] = useState(true);
  const [selectedIndex, setSelectedIndex] = useState(0);
  const [scrollSnaps, setScrollSnaps] = useState<number[]>([]);

  const scrollPrev = useCallback(
    () => emblaApi && emblaApi.scrollPrev(),
    [emblaApi]
  );
  const scrollNext = useCallback(
    () => emblaApi && emblaApi.scrollNext(),
    [emblaApi]
  );
  const scrollTo = useCallback(
    (index: number) => emblaApi && emblaApi.scrollTo(index),
    [emblaApi]
  );

  const onInit = useCallback((embla: EmblaCarouselType) => {
    setScrollSnaps(embla.scrollSnapList());
  }, []);

  const onSelect = useCallback((embla: EmblaCarouselType) => {
    setSelectedIndex(embla.selectedScrollSnap());
    setPrevBtnDisabled(!embla.canScrollPrev());
    setNextBtnDisabled(!embla.canScrollNext());
  }, []);

  const prevButton = useMemo(
    () => ({ onClick: scrollPrev, disabled: prevBtnDisabled }),
    [prevBtnDisabled, scrollPrev]
  );

  const nextButton = useMemo(
    () => ({ onClick: scrollNext, disabled: nextBtnDisabled }),
    [nextBtnDisabled, scrollNext]
  );

  useEffect(() => {
    if (!emblaApi) return;

    onInit(emblaApi);
    onSelect(emblaApi);
    emblaApi.on("reInit", onInit);
    emblaApi.on("reInit", onSelect);
    emblaApi.on("select", onSelect);
  }, [emblaApi, onInit, onSelect]);

  return {
    emblaRef,
    prevButton,
    nextButton,
    selectedIndex,
    scrollSnaps,
    scrollTo
  };
};

export default useImageComparisonSlider;
